export const summaryRows: string[] = [
  'Volume 1 — Electric Motor Fundamentals',
  'Volume 2 — Induction Motor Performance & Selection',
  'Volume 3 — Motor Starting, Control & Protection',
  'Volume 4 — Variable Frequency Drives (VFD)',
  'Volume 5 — Motor Testing & Condition Monitoring',
  'Volume 6 — Maintenance, Troubleshooting & Reliability',
  'Bonus 1 — Motor Nameplate & Datasheet Decoder',
  'Bonus 2 — VFD Fault Diagnosis Field Guide',
  'Bonus 3 — Motor Inspection & Testing Checklists',
  'Bonus 4 — Motor Formulas & Quick Calculations',
  'Bonus 5 — Hazardous Area (Ex) Motors Essentials',
  '7-day money-back guarantee',
  'Instant access',
];
